import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryCard from '@/components/base/CategoryCard';
import FAQ from '@/components/base/FAQ';
import { categories, articles, faqs } from '@/mocks/data';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'JM漫画导航 - jmcomic-zzz.one',
      url: 'https://jmcomic-zzz.one',
      description: 'JM漫画官方入口导航平台，提供最新访问地址、镜像站列表、内容分类导航及常见问题解答。',
    },
    {
      '@type': 'WebSite',
      name: 'jmcomic-zzz.one',
      url: 'https://jmcomic-zzz.one',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://jmcomic-zzz.one/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: 'jmcomic-zzz.one 首页 - JM漫画官方入口导航',
      url: 'https://jmcomic-zzz.one/',
      isPartOf: { '@id': 'https://jmcomic-zzz.one/#website' },
      about: { '@id': 'https://jmcomic-zzz.one/#organization' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />

      <main>
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20abstract%20background%20with%20warm%20orange%20and%20deep%20crimson%20gradient%2C%20ink%20wash%20painting%20texture%2C%20artistic%20comic%20book%20atmosphere%2C%20dynamic%20brush%20strokes%2C%20dramatic%20lighting%2C%20clean%20composition%20with%20empty%20center%20for%20text%20overlay&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
            alt="JM漫画导航背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4 md:mb-6 leading-tight">
              jmcomic-zzz.one 官方入口
            </h1>
            <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
              JM漫画最新域名导航与访问指南，提供最新地址、镜像站列表、内容分类导航及常见问题解答，帮助您快速稳定连接JM漫画平台
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://jmcomic-zzz.one"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                立即访问JM漫画
              </a>
              <Link
                to="/category"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 backdrop-blur-sm text-white font-medium rounded-md hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer border border-white/30"
              >
                <i className="ri-compass-3-line"></i>
                查看使用指南
              </Link>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-12">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
                快速导航
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                选择您需要的服务，快速找到JM漫画相关内容
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <CategoryCard key={cat.slug} category={cat} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-12 gap-4">
              <div>
                <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
                  最新文章
                </h2>
                <p className="text-foreground-600 text-sm">
                  最新发布的JM漫画相关资讯与指南
                </p>
              </div>
              <Link
                to="/category"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-12">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-600 text-sm">
                关于jmcomic-zzz.one的常见疑问解答
              </p>
            </div>
            <FAQ items={faqs} />
          </div>
        </section>

        <section className="py-12 md:py-16 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20toned%20manga%20illustration%20background%2C%20soft%20orange%20and%20amber%20gradient%20with%20ink%20texture%2C%20Japanese%20comic%20art%20style%2C%20abstract%20dynamic%20composition%2C%20artistic%20atmosphere%20with%20subtle%20brush%20strokes&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 to-foreground-950/60"></div>
          <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
              立即访问JM漫画，畅享海量内容
            </h2>
            <p className="text-foreground-300 text-sm md:text-base mb-6 max-w-xl mx-auto">
              收藏本导航页面，随时随地快速连接到JM漫画平台，不错过任何精彩内容
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://jmcomic-zzz.one"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-950 font-medium rounded-md hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-rocket-line"></i>
                进入JM漫画
              </a>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}